/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Stage-entry diagnosis for the actor's current intended stage.
 */
export interface OralExamStageGateResponse {
  stage: string;
  ok: boolean;
  code: string;
  messageKey: string;
}
